// extracted by mini-css-extract-plugin
export default {"backHeaderContainer":"FavoritesEmptyState_backHeaderContainer--gHW","subText":"FavoritesEmptyState_subText--aVV"};